import { DASHBOARD_COLORS } from "../../../dashboard-framework/colors";
import { EXCLUDE_INTERNAL_SESSIONS_FILTER } from "../../../dashboard-framework/commonFilters";
import { AggregateQuerySpec, ChartSeriesConfig, GlobalFilterConfig } from "../../../dashboard-framework/types";
import { FINISHED_STATUSES, NFB_PSY_SERVICES } from "../shared/sharedMetrics";

// Fórmulas extraídas do Zoho "Sessions and Treatments Analysis" em 2026-06-11 (ver spec.md):
// iniciados/terminados = contagens mensais de date_of_start/date_if_finish sem filtros (validado exato);
// terminados p/ análise = status done/client_decided_is_ok/sporadic/cliente_gave_up; sucesso vs desistência
// validado exato (Jun 2025: 10/20/66.7%); ativos = all_good por tipo de cliente (validado exato 183/17);
// sessões futuras = próximos 12 meses, tratamento all_good, serviços NFB/Psi, SEM excluir internas.

export const SESSIONS_TREATMENTS_KEY = "sessions-treatments";

// Movidos para shared/sharedMetrics.ts (usados por 2+ dashboards); re-exportados para não partir os imports existentes.
export { DECLINED_STATUS, FINISHED_STATUSES, SUCCESS_STATUSES } from "../shared/sharedMetrics";

export const FINISHED_ANALYSIS_SINCE = "2022-01-01";

// Filtro de datas partilhado no topo do dashboard: por defeito os últimos 13 meses (12 meses completos
// + o mês corrente parcial). Aplica-se aos widgets históricos (iniciados vs terminados, média de sessões,
// análise de tratamentos terminados, sucesso). Os cartões de ativos, as sessões futuras e os parceiros
// mantêm a sua própria semântica (fotografia atual / futuro / histórico total).
export const sessionsTreatmentsGlobalFilters: Array<GlobalFilterConfig> = [
    {
        key: "period",
        type: "datePreset",
        label: "Período",
        field: "date_if_finish",
        defaultPreset: "ultimos_13_meses",
        presets: ["este_mes", "ultimos_3_meses", "ultimos_6_meses", "este_ano", "ultimos_12_meses", "ultimos_13_meses"],
    },
];

export const startedMonthlyQuery: AggregateQuerySpec = {
    entity: "treatments",
    aggregate: { count: "*" },
    groupBy: ["year(date_of_start)", "month(date_of_start)"],
    dataScope: "global",
};

export const finishedMonthlyQuery: AggregateQuerySpec = {
    entity: "treatments",
    aggregate: { count: "*" },
    groupBy: ["year(date_if_finish)", "month(date_if_finish)"],
    dataScope: "global",
};

export const sessionsPerFinishedTreatmentQuery: AggregateQuerySpec = {
    entity: "sessions",
    aggregate: { count: "*" },
    groupBy: ["treatment", "service"],
    fixedFilter: {
        _and: [
            { service: { _in: NFB_PSY_SERVICES } },
            EXCLUDE_INTERNAL_SESSIONS_FILTER,
            { treatment: { treatment_status_new: { _in: FINISHED_STATUSES } } },
            { treatment: { date_if_finish: { _gte: FINISHED_ANALYSIS_SINCE } } },
        ],
    },
    dataScope: "global",
};

export const futureSessionsByServiceQuery: AggregateQuerySpec = {
    entity: "sessions",
    aggregate: { count: "*" },
    groupBy: ["service"],
    fixedFilter: {
        _and: [{ service: { _in: NFB_PSY_SERVICES } }, { treatment: { treatment_status_new: { _eq: "all_good" } } }],
    },
    dataScope: "global",
};

export const activeTreatmentsQuery: AggregateQuerySpec = {
    entity: "treatments",
    aggregate: { count: "*" },
    fixedFilter: { treatment_status_new: { _eq: "all_good" } },
    dataScope: "global",
};

export const treatmentsTotalQuery: AggregateQuerySpec = {
    entity: "treatments",
    aggregate: { count: "*" },
    dataScope: "global",
};

export const startedFinishedSeries: Array<ChartSeriesConfig> = [
    { key: "started", label: "Tratamentos iniciados", color: DASHBOARD_COLORS.done },
    { key: "finished", label: "Tratamentos terminados", color: DASHBOARD_COLORS.cancelled },
];

export const successSeries: Array<ChartSeriesConfig> = [
    { key: "success", label: "Sucesso", color: DASHBOARD_COLORS.done },
    { key: "declined", label: "Desistência", color: DASHBOARD_COLORS.cancelled },
    { key: "successPct", label: "% sucesso", color: DASHBOARD_COLORS.highlight, rightAxis: true },
];

export const avgSessionsSeries: Array<ChartSeriesConfig> = [
    { key: "avgSessions", label: "Média de sessões por tratamento", color: DASHBOARD_COLORS.highlight },
];
